// web/src/redux/services/inventoryApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const inventoryApi = createApi({
  reducerPath: "inventoryApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND_URL || "http://localhost:7600/api",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.auth?.token || localStorage.getItem("token");
      if (token) headers.set("Authorization", `Bearer ${token}`);
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  tagTypes: ["Inventory", "InventoryTxns"],
  endpoints: (builder) => ({
    listItems: builder.query({
      query: (params = {}) => {
        const qs = new URLSearchParams(params).toString();
        return `/inventory/items${qs ? `?${qs}` : ""}`;
      },
      providesTags: ["Inventory"],
    }),

    createItem: builder.mutation({
      query: (body) => ({ url: "/inventory/items", method: "POST", body }),
      invalidatesTags: ["Inventory"],
    }),

    updateItem: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/inventory/items/${id}`, method: "PUT", body }),
      invalidatesTags: ["Inventory"],
    }),

    deleteItem: builder.mutation({
      query: (id) => ({ url: `/inventory/items/${id}`, method: "DELETE" }),
      invalidatesTags: ["Inventory"],
    }),

    stockIn: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/inventory/items/${id}/stock-in`, method: "POST", body }),
      invalidatesTags: ["Inventory"],
    }),

    assign: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/inventory/items/${id}/assign`, method: "POST", body }),
      invalidatesTags: ["Inventory", "InventoryTxns"],
    }),

    transfer: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/inventory/items/${id}/transfer`, method: "POST", body }),
      invalidatesTags: ["Inventory", "InventoryTxns"],
    }),

    returnToWarehouse: builder.mutation({
      query: ({ id, ...body }) => ({ url: `/inventory/items/${id}/return`, method: "POST", body }),
      invalidatesTags: ["Inventory", "InventoryTxns"],
    }),

    listTxns: builder.query({
      query: (params = {}) => {
        const qs = new URLSearchParams(params).toString();
        return `/inventory/txns${qs ? `?${qs}` : ""}`;
      },
      providesTags: ["InventoryTxns"],
    }),
    // add endpoints
searchOwners: builder.query({
  query: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return `/inventory/owners${qs ? `?${qs}` : ""}`;
  },
}),

listItemUnits: builder.query({
  query: ({ id, ...params }) => {
    const qs = new URLSearchParams(params).toString();
    return `/inventory/items/${id}/units${qs ? `?${qs}` : ""}`;
  },
  providesTags: ["Inventory"],
}),

listItemTxnsByItem: builder.query({
  query: ({ id }) => `/inventory/items/${id}/txns`,
  providesTags: ["InventoryTxns"],
}),

  }),
});

export const {
  useListItemsQuery,
  useCreateItemMutation,
  useUpdateItemMutation,
  useDeleteItemMutation,
  useStockInMutation,
  useAssignMutation,
  useTransferMutation,
  useReturnToWarehouseMutation,
  useListTxnsQuery,
   useSearchOwnersQuery,
  useLazySearchOwnersQuery,
  useListItemUnitsQuery,
  useListItemTxnsByItemQuery,
} = inventoryApi;
